<template>
    <tr class="lms__superadmin_users_bulk_actions_delete_profiles_summary_table_item">
        <td class="lms__superadmin_users_bulk_actions_delete_profiles_summary_table_item_firstname">
            <div class="columns is-vcentered">
                <div class="column">
                    {{ userFirstName }}
                </div>
            </div>
        </td>
        <td class="lms__superadmin_users_bulk_actions_delete_profiles_summary_table_item_lastname">
            <div class="columns is-vcentered">
                <div class="column">
                    {{ userLastName }}
                </div>
            </div>
        </td>
        <td class="lms__superadmin_users_bulk_actions_delete_profiles_summary_table_item_email">
            {{ userEmail }}
        </td>
        <td class="lms__superadmin_users_bulk_actions_delete_profiles_summary_table_item_status">
            <component-status :status="userUpdateStatus" :force-success="userUpdateStatus === 'archived'"/>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { User } from '@/User'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentBadgeRole from '@/components/default/shared/ComponentBadgeRole'
import ComponentBadgeRolesList from '@/components/default/shared/ComponentBadgeRolesList'
import ComponentTextList from '@/components/default/shared/ComponentTextList'
import ListTableCheck from '@/components/default/shared/ListTableCheck'

export default {
  name: 'lms-superadmin-users-bulk-actions-delete-profiles-summary-table-item',
  components: { ListTableCheck, ComponentTextList, ComponentBadgeRolesList, ComponentBadgeRole, ComponentButtonMenu, ComponentStatus, ComponentButton },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    }
  },
  computed: {
    isUserSelected () {
      const selected = this.selected
      const userProfileId = this.userProfileId

      return selected && selected.length ? selected.includes(userProfileId) : false
    },
    userUpdateStatus () {
      return this.item.updateStatus
    },
    userProfileId () {
      return this.item.profileId
    },
    userFirstName () {
      return this.item.firstName
    },
    userLastName () {
      return this.item.lastName
    },
    userEmail () {
      return this.item.emailAddress
    },
    userProfileStatus () {
      let firstProfile
      let status

      status = this.item.profileStatus

      return status
    },
    userProfileRoles () {
      let firstProfile
      let roles

      roles = this.userRoles

      return roles
    },
    userProfileOrgUnitName () {
      const orgUnit = this.item.organisationUnit
      return orgUnit ? orgUnit.name : ''
    },
    userProfileGroups () {
      const groups = this.item.groups
      return groups ? groups.map(obj => obj.name) : []
    },
    userRoles () {
      return this.item.roles
    }
  }
}
</script>
